<template>
    <span class="footer-buttons">
        <v-btn
            @click="store.SetState('addtocart_trigger', addtocart_trigger + 1)"
            v-if="!config_drawer && configurator"
            :size="ResizeButtonOnSmallScreen"
            prepend-icon="mdi-plus-circle"
            :width="is_mobile?'100%':''"
            class="mt-2 mb-md-2 mr-2"
            :color="ConfigElementsColor"
            text="Add to Quote"
            rounded="pill">
        </v-btn>
        <v-btn
            @click="store.SetState('cart_modal', false)"
            :size="ResizeButtonOnSmallScreen"
            v-if="cart_modal && !is_mobile"
            :width="is_mobile ? '100%' : '175'"
            prepend-icon="mdi-plus"
            class="mt-2 mb-2 mr-2"
            :color="ConfigElementsColor"
            text="Add more..."
            rounded="pill">
        </v-btn>
        <v-btn
            prepend-icon="mdi-file-document-edit"
            :disabled="cart_items.length===0"
            :size="ResizeButtonOnSmallScreen"
            :width="is_mobile ? '100%' : '175'"
            :color="ConfigElementsColor"
            @click="OpenFormModal"
            text="Request Quote"
            class="mt-2 mb-2"
            rounded="pill">
        </v-btn>
    </span>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { storeToRefs } from 'pinia'
import { useGlobalsStore } from '@/stores/globals'

const store = useGlobalsStore()
const {
  is_mobile,
  cart_items,
  cart_modal,
  configurator,
  config_drawer,
  addtocart_trigger,
  ConfigElementsColor
} = storeToRefs(store)

const ResizeButtonOnSmallScreen = computed(() => {
  return is_mobile.value ? 'small' : 'default'
})

function OpenFormModal() {
  store.FormSelector()
  store.SetState('form_modal', true)
}
</script>
